import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-table" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "description" }
const _hoisted_4 = { class: "answers-list" }
const _hoisted_5 = { class: "questions-title" }
const _hoisted_6 = {
  key: 0,
  class: "one"
}
const _hoisted_7 = {
  key: 1,
  class: "more"
}
const _hoisted_8 = {
  key: 2,
  class: "short"
}
const _hoisted_9 = { class: "short-answewr" }
const _hoisted_10 = {
  key: 3,
  class: "short"
}
const _hoisted_11 = { class: "short-answewr" }

import { ref, reactive, onMounted } from "vue";
import { getListExamUsers, getExamInfo } from '@/api/backstage';
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'questionsDetails',
  setup(__props) {

const route = useRoute();

const dialogPreview = ref(false); //详情弹框是否打开

const datas: any = reactive({
  tableList: [], //表格数据
  total: 0,
  form: {
    pageSize: 10,
    pageNum: 1,
    examId: route.query.id,
  },
  detailsList: [], //详情列表
  type: {
    QUESTION_ONE:{
      enumName: '单选',
      enumKey: 'QUESTION_ONE'
    },
    QUESTION_MORE:{
      enumName: '多选',
      enumKey: 'QUESTION_MORE'
    },
    QUESTION_SHORT:{
      enumName: '简答',
      enumKey: 'QUESTION_SHORT'
    },
      QUESTION_NUM: {
      enumName: "打分",
      enumKey: "QUESTION_NUM",
    },
  },
});

//获取列表数据
const getList = async() => {
  const res = await getListExamUsers(datas.form);
  datas.tableData =  res.data.list;
  datas.total = res.data.total;
};

// 去除p标签
const stripHTMLTags=(html)=> {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  };

//查看答题详情
const openDetails = (row: any) => {
  dialogPreview.value = true;
  getExamInfo({
    examUserId: row.id,
    id: row.examId,
  }).then((res: any) => {
    datas.detailsList = res.data;
    datas.detailsList.questions = res.data.questions.map((item: any) => {
      return {
        ...item,
        answer: item.type === 'QUESTION_MORE' ? item.answer.trim().split(',') : item.answer, //如果是多选将字符串转换为数组方便与选项做对比
        options: 
          //item.options为null时该项为简答题
          //然后判断type是否为多选,多选时选项做特殊处理，添加checked属性
          item.options ? (item.type === 'QUESTION_MORE' ? [...item.options.map((childItem: any) => {
             return {
              ...childItem,
              //用每一项的title去跟已选项做对比得到选中状态
              checked: item.answer.includes(childItem.title)
             };
          })] : item.options) : item.options
      };
    });
  });
};

const handleSizeChange = (val: number) => {
  datas.form.pageSize = val;
  getList();
};
const handleCurrentChange = (val: number) => {
  datas.form.pageNum = val;
  getList();
};

onMounted(() => {
  getList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_table, {
      data: datas.tableData,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          align: "center",
          type: "index",
          width: "80",
          label: "序号"
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          prop: "examName",
          label: "问卷"
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          prop: "createTime",
          label: "创建时间"
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          prop: "sortNum",
          label: "操作"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_button, {
              type: "text",
              onClick: ($event: any) => (openDetails(row))
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("查看详情", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_pagination, {
      currentPage: datas.form.pageNum,
      "page-size": datas.form.pageSize,
      "page-sizes": [10, 20, 50, 100],
      background: "",
      layout: "total, sizes, prev, pager, next, jumper",
      total: Number(datas.total),
      onSizeChange: handleSizeChange,
      onCurrentChange: handleCurrentChange
    }, null, 8, ["currentPage", "page-size", "total"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogPreview.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogPreview).value = $event)),
      title: "",
      width: "50%"
    }, {
      default: _withCtx(() => [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(datas.detailsList.title), 1),
        _createElementVNode("h3", _hoisted_3, _toDisplayString(datas.detailsList.description), 1),
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.detailsList.questions, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "answers-item",
              key: item.id
            }, [
              _createElementVNode("div", _hoisted_5, [
                (item.mustStatus === 1)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass({mustStatus: item.mustStatus === 1})
                    }, "*", 2))
                  : _createCommentVNode("", true),
                _createTextVNode(_toDisplayString(index + 1) + ". " + _toDisplayString(stripHTMLTags(item.title)) + " ", 1),
                _createVNode(_component_el_tag, {
                  class: "ml-2",
                  type: "info"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(datas.type[item.type]?.enumName), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              (datas.type[item.type]?.enumName === '单选')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_el_radio_group, {
                      modelValue: item.answer,
                      "onUpdate:modelValue": ($event: any) => ((item.answer) = $event),
                      class: "ml-4"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (optionItem) => {
                          return (_openBlock(), _createBlock(_component_el_radio, {
                            label: optionItem.title,
                            size: "large",
                            key: optionItem.id,
                            disabled: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(optionItem.description), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (datas.type[item.type]?.enumName === '多选')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (optionItem) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        modelValue: optionItem.checked,
                        "onUpdate:modelValue": ($event: any) => ((optionItem.checked) = $event),
                        label: optionItem.description,
                        size: "large",
                        key: optionItem.id,
                        disabled: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (datas.type[item.type]?.enumName === '打分')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(item.answer ? item.answer+'分' : '未填写'), 1)
                  ]))
                : _createCommentVNode("", true),
              (datas.type[item.type]?.enumName === '简答')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(item.answer ? item.answer : '未填写'), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})